export const EXPIRED_WELCOME_LINK_MESSAGE =
  "This welcome link has expired. Please contact your account executive for a new link.";